export const primary = {
  100: `#096348`,// TODO: remove
  90: `#096348`,
  80: `#0A855C`,
  70: `#0BAD71`,
  60: `#0BD081`,
  50: `#0AEB8B`,
  40: `#25F896`,
  30: `#69FCB2`,
  20: `#A4FECE`,
  10: `#DBFFEB`,
  0: `#F0FFF6`
}

export const neutral = {
  100: `#28333E`, // TODO: remove
  90: `#28333E`,
  80: `#323F4B`,
  70: `#3E4C59`,
  60: `#52606D`,
  50: `#616E7C`,
  40: `#7B8794`,
  30: `#9AA5B1`,
  20: `#CBD2D9`,
  10: `#E4E7EB`,
  0: `#F6F7F9`
}

export const background = {
  20: `#F2EFE3`,
  10: `#F9F7F1`,
  0: `#FCFBF8`,
}

export const secondary1 = {
  90: `#8E0B21`,
  80: `#AD0B2B`,
  70: `#CB0B38`,
  60: `#E10943`,
  50: `#F80B53`,
  40: `#FB417F`,
  30: `#FE72A5`,
  20: `#FEAECE`,
  10: `#FFE0EE`,
  0: `#FFF5FA`
}

export const secondary2 = {
  90: `#7A5600`,
  80: `#A87000`,
  70: `#CC8100`,
  60: `#F09000`,
  50: `#FF970B`,
  40: `#FFAB2E`,
  30: `#FFC170`,
  20: `#FFD9AD`,
  10: `#FFEBD6`,
  0: `#FFF7F0`
}

export const tertiary = {
  90: `#853700`,
  80: `#AD4200`,
  70: `#D14900`,
  60: `#EB4A00`,
  50: `#FF500B`,
  40: `#FF6633`,
  30: `#FF8766`,
  20: `#FFAC99`,
  10: `#FFDCD6`,
  0: `#FFF1F0`
}

export const blue = {
  100: `#003E6B`,
  90: `#0A558C`,
  80: `#0F609B`,
  70: `#186FAF`,
  60: `#2680C2`,
  50: `#4098D7`,
  40: `#62B0E8`,
  30: `#84C5F4`,
  20: `#B6E0FE`,
  10: `#DCEEFB`
}

export const purple = {
  100: `#240754`,
  90: `#34126F`,
  80: `#421987`,
  70: `#51279B`,
  60: `#653CAD`,
  50: `#724BB7`,
  40: `#8662C7`,
  30: `#A081D9`,
  20: `#CFBCF2`,
  10: `#EAE2F8`
}

export const red = {
  100: `#610404`,
  90: `#780A0A`,
  80: `#911111`,
  70: `#A61B1B`,
  60: `#BA2525`,
  50: `#D64545`,
  40: `#E66A6A`,
  30: `#F29B9B`,
  20: `#FACDCD`,
  10: `#FFEEEE`
}

export const yellow = {
  100: `#513C06`,
  90: `#7C5E10`,
  80: `#A27C1A`,
  70: `#C99A2E`,
  60: `#E9B949`,
  50: `#F7D070`,
  40: `#F9DA8B`,
  30: `#F8E3A3`,
  20: `#FCEFC7`,
  10: `#FFFAEB`
}
